import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-cream-300 bg-white px-4 py-10" data-id="element-151" data-mp="1tbt6hb1wc1ig">
      <div className="mx-auto max-w-5xl" data-id="element-152" data-mp="1oalzhe7kv6cu">
        <p className="flex items-center justify-center gap-1.5 font-sans text-[10px] font-bold uppercase tracking-[0.28em] text-ink-muted" data-id="element-153" data-mp="1odhyl5v5w12v">
          <SparklesIcon className="h-3 w-3 text-brand" aria-hidden="true" data-id="element-154" data-mp="1edr3p32ovk29" />
          I numeri del progetto
        </p>

        <dl className="mt-7 grid grid-cols-2 gap-y-8 sm:grid-cols-4" data-id="element-155" data-mp="19lg2zy04ju8n">
          {stats.map(stat => <div key={stat.label} className="text-center" data-id="element-156" data-mp="15lp57ac6kdum">
              <dt className="sr-only" data-id="element-157" data-mp="10m2rkzsfwvla">{stat.label}</dt>
              <dd data-id="element-158" data-mp="10ndwj2xmg9dz">
                <span className="block font-display text-[30px] font-black leading-none text-ink sm:text-[34px]" data-id="element-159" data-mp="10jq3e4w39ozs">
                  {stat.value}
                </span>
                <span className="mt-2 block font-sans text-[10px] font-semibold uppercase tracking-[0.16em] text-ink-muted" data-id="element-160" data-mp="qoy1wpzdyhzq">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}